/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { upperFirst } from 'lodash'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function AssigneeField (props: FormTextFieldProps) {
  const intl = useIntl()
  const { name = 'assignee', ...others } = props
  return (
    <FormField
      label={intl.formatMessage({
        id: 'assignee',
        defaultMessage: 'Responsable'
      })}
      name={name}
      parser={upperFirst}
      {...others}
    />
  )
}

export default AssigneeField
